import { useChatApp, useCurrentUser } from '@common/hooks';
import { createCookie, createRandomString, textTools } from '@common/utils';
import { RsButton } from '../RsButton';
import { Slack } from '@common/assets/images/Slack';

/** createState - create a random state value and store on the client
 * as a secure HTML only cookie. This state value will be used to verify the
 * returned state value from the OAuth2 server.
 */
const createState = (uid, orgId) => {
	const randomString = createRandomString(24);
	const state = `${uid}:${orgId}:${randomString}`;
	const b64 = textTools.encode(state);
	return b64;
};

export const AddToSlackButton = ({ sx }) => {
	const { config } = useChatApp();
	const { user } = useCurrentUser();

	if (!user || !user.uid || !user.currentOrg.orgId) return null;

	/**
	 * constructs a state value from the userId, orgId, and a random string
	 * stores the state value in a secure session cookie for later verification
	 * redirects the user to Slack to authorize the app
	 */
	const handleClick = () => {
		const userId = user?.uid;
		const orgId = user?.currentOrg?.orgId;
		// create a state value including the uid and orgId and random string
		const state = createState(userId, orgId);
		// store the state value in a secure session cookie - no expiry date
		createCookie('slackConnectState', state, null, 1 / 12);
		// append the state value to the oauth_url
		const url = `${config.oauth_url}&state=${state}`;
		// redirect the user to the oauth_url
		window.location.replace(url);
	};

	return (
		<RsButton
			variant="contained"
			sx={{
				minHeight: '3rem',
				...sx,
			}}
			onClick={handleClick}
		>
			<Slack size="1.8rem" style={{ marginRight: '1rem' }} />
			Add to Slack
		</RsButton>
	);
};
